/* Everything Bundle 2026 landing page runtime (new file only).
   Ports the Claude Design page behavior 1:1:
   - ?credit=NN.NN display-only price preview (real discount applied by Shopify discount link)
   - countdown timers (sticky bar + bonuses section)
   - sticky bar reveal after hero scrolls out
   - offer ledger modal + in-page expander
   - Legends audio A/B demo (tabs, one clip at a time, progress bars)
   - tone stats count-up */
(function () {
  'use strict';
  if (window.__ebInit) return;
  window.__ebInit = true;

  function money(n) {
    return '$' + (Math.round(n * 100) % 100 === 0
      ? n.toLocaleString('en-US', { maximumFractionDigits: 0 })
      : n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
  }

  function init() {
    // ---- Account credit (display-only math) ----
    var urlCredit = new URLSearchParams(window.location.search).get('credit');
    if (!urlCredit) {
      // Fallback: catch credit= even if the URL arrived with encoded separators (%3F / %3D)
      var m = decodeURIComponent(window.location.href).match(/[?&]credit=([0-9.]+)/i);
      if (m) urlCredit = m[1];
    }
    // Keep the leading minus while sanitizing so "credit=-5" parses negative (and is
    // then rejected below) instead of being silently turned into a positive credit.
    var credit = parseFloat(String(urlCredit || '').replace(/[^0-9.\-]/g, '')) || 0;

    var base2026 = 199, baseColl = 299;
    var pagePrices = [];
    var cfg = document.querySelector('[data-eb-prices]');
    if (cfg) {
      var a2026 = parseFloat(cfg.getAttribute('data-eb-price-2026'));
      var aColl = parseFloat(cfg.getAttribute('data-eb-price-coll'));
      if (isFinite(a2026)) { base2026 = a2026; pagePrices.push(a2026); }
      if (isFinite(aColl)) { baseColl = aColl; pagePrices.push(aColl); }
    }
    // Sanity clamp: the credit is display-only. If it is missing, non-numeric, or too
    // large for the cheapest tier offered on this page, fall back to the standard
    // no-credit presentation instead of showing $0 / negative prices.
    if (!isFinite(credit) || credit <= 0 || (pagePrices.length && credit >= Math.min.apply(null, pagePrices))) {
      credit = 0;
    }
    var hasCredit = credit > 0;
    var p2026 = money(hasCredit ? Math.max(0, base2026 - credit) : base2026);
    var pColl = money(hasCredit ? Math.max(0, baseColl - credit) : baseColl);

    document.querySelectorAll('[data-eb-p2026]').forEach(function (el) { el.textContent = p2026; });
    document.querySelectorAll('[data-eb-pcoll]').forEach(function (el) { el.textContent = pColl; });
    document.querySelectorAll('[data-eb-from-price]').forEach(function (el) { el.textContent = 'Yours from ' + p2026; });
    if (hasCredit) {
      document.querySelectorAll('[data-eb-credit-show]').forEach(function (el) { el.hidden = false; });
      document.querySelectorAll('[data-eb-credit-hide]').forEach(function (el) { el.hidden = true; });
      document.querySelectorAll('[data-eb-credit-label]').forEach(function (el) { el.textContent = '-' + money(credit); });
      document.querySelectorAll('[data-eb-credit-plain]').forEach(function (el) { el.textContent = money(credit); });
      // Show the arithmetic on single-tier pages: "$299 - $121.98 = $177.02"
      document.querySelectorAll('[data-eb-math-2026]').forEach(function (el) {
        el.textContent = money(base2026) + ' - ' + money(credit) + ' = ' + p2026;
      });
      document.querySelectorAll('[data-eb-math-coll]').forEach(function (el) {
        el.textContent = money(baseColl) + ' - ' + money(credit) + ' = ' + pColl;
      });
    }

    // ---- Countdown (evergreen) ----
    // Driven ONLY by an ?expires= ISO datetime in the URL (promo links carry it, like
    // ?credit=). Absent, invalid, or already past => every countdown/urgency element
    // stays hidden and the page reads evergreen. Section 'deadline' settings are no
    // longer consulted. The markup ships the evergreen wraps pre-hidden (no flash);
    // promo-page (CO/CE/VIP) wraps are hidden here at init instead.
    function urgencyWraps() {
      var els = [];
      document.querySelectorAll('[data-eb-timer]').forEach(function (el) {
        els.push(el.closest('[data-eb-countdown-box]') || el.parentElement || el);
      });
      document.querySelectorAll('[data-eb-timer-sticky]').forEach(function (el) {
        els.push(el.closest('.eb-sticky-timer-wrap') || el.parentElement || el);
      });
      document.querySelectorAll('[data-eb-urgency]').forEach(function (el) { els.push(el); });
      return els;
    }
    var expiresRaw = new URLSearchParams(window.location.search).get('expires');
    var deadline = expiresRaw ? Date.parse(String(expiresRaw)) : NaN;
    var urgencyLive = isFinite(deadline) && deadline > Date.now();
    urgencyWraps().forEach(function (el) { el.hidden = !urgencyLive; });
    if (urgencyLive) {
      var pad = function (n) { return String(n).padStart(2, '0'); };
      var timerId = setInterval(tick, 1000); // tick is hoisted
      function tick() {
        var ms = deadline - Date.now();
        if (ms <= 0) { // expired while viewing: drop back to evergreen
          urgencyWraps().forEach(function (el) { el.hidden = true; });
          clearInterval(timerId);
          return;
        }
        var d = Math.floor(ms / 86400000), h = Math.floor(ms / 3600000) % 24;
        var mm = Math.floor(ms / 60000) % 60, s = Math.floor(ms / 1000) % 60;
        var full = d + 'D ' + pad(h) + ':' + pad(mm) + ':' + pad(s);
        var brief = d + 'D ' + pad(h) + ':' + pad(mm);
        var mobile = window.innerWidth < 768;
        document.querySelectorAll('[data-eb-timer]').forEach(function (el) { el.textContent = full; });
        document.querySelectorAll('[data-eb-timer-sticky]').forEach(function (el) { el.textContent = mobile ? brief : full; });
      }
      tick();
    }

    // ---- Tone stats count-up ----
    function countUp() {
      var band = document.getElementById('tone-stats');
      if (!band || band.dataset.done) return;
      if (band.getBoundingClientRect().top > window.innerHeight - 120) return;
      band.dataset.done = '1';
      band.querySelectorAll('[data-count]').forEach(function (el) {
        var raw = el.getAttribute('data-count');
        var target = parseInt(raw.replace(/[^0-9]/g, ''), 10);
        var suffix = raw.replace(/[0-9,]/g, '');
        var t0 = performance.now(), dur = 1100;
        var step = function (now) {
          var p = Math.min(1, (now - t0) / dur);
          var v = Math.round(target * (1 - Math.pow(1 - p, 3)));
          el.textContent = v.toLocaleString() + suffix;
          if (p < 1) requestAnimationFrame(step);
        };
        el.textContent = '0' + suffix;
        requestAnimationFrame(step);
      });
    }

    // ---- Sticky bar ----
    var bar = document.querySelector('[data-eb-sticky]');
    function onScroll() {
      if (bar) {
        var hero = document.getElementById('hero');
        var on = hero ? hero.getBoundingClientRect().bottom < 0 : window.scrollY > 600;
        bar.classList.toggle('eb-sticky-on', on);
      }
      countUp();
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    // ---- Full product list expander ----
    var listWrap = document.querySelector('[data-eb-list]');
    var listBtn = document.querySelector('[data-eb-list-toggle]');
    function setList(open) {
      if (!listWrap) return;
      listWrap.classList.toggle('eb-open', open);
      if (listBtn) listBtn.textContent = open ? 'Hide Full Product List' : 'See Full Product List';
    }
    if (listBtn) listBtn.addEventListener('click', function () { setList(!listWrap.classList.contains('eb-open')); });
    document.querySelectorAll('[data-eb-open-list]').forEach(function (a) {
      a.addEventListener('click', function () { if (listWrap && !listWrap.classList.contains('eb-open')) setList(true); });
    });

    // ---- Offer ledger modal ----
    var modal = document.querySelector('[data-eb-modal]');
    function openModal() {
      if (!modal) return;
      modal.classList.add('eb-open');
      document.documentElement.classList.add('eb-modal-lock');
    }
    function closeModal() {
      if (!modal) return;
      modal.classList.remove('eb-open');
      document.documentElement.classList.remove('eb-modal-lock');
    }
    document.querySelectorAll('[data-eb-open-modal]').forEach(function (b) { b.addEventListener('click', openModal); });
    document.querySelectorAll('[data-eb-close-modal]').forEach(function (b) { b.addEventListener('click', closeModal); });
    if (modal) {
      modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
      window.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });
      modal.querySelectorAll('[data-eb-modal-cta]').forEach(function (cta) {
        cta.addEventListener('click', function (e) {
          e.preventDefault();
          closeModal();
          var el = document.getElementById('choose');
          if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 80, behavior: 'smooth' });
        });
      });
    }

    // ---- Legends audio A/B demo ----
    var PLAY = 'M6 3.5L20 12L6 20.5V3.5Z', PAUSE = 'M6 4h4v16H6zM14 4h4v16h-4z';
    var pool = {}, playing = null;
    var pendingEl = document.querySelector('[data-eb-audio-pending]');
    function setIcon(key, on) {
      var p = document.querySelector('[data-eb-icon="' + key + '"]');
      if (p) p.setAttribute('d', on ? PAUSE : PLAY);
    }
    function resetBar(key) {
      var b = document.querySelector('[data-eb-pct="' + key + '"]');
      if (b) b.style.width = '0%';
    }
    function getAudio(key, src) {
      if (!pool[key]) {
        var a = new Audio(src);
        a.preload = 'metadata';
        a.addEventListener('timeupdate', function () {
          if (!a.duration) return;
          var b = document.querySelector('[data-eb-pct="' + key + '"]');
          if (b) b.style.width = Math.min(100, (a.currentTime / a.duration) * 100) + '%';
        });
        a.addEventListener('ended', function () {
          if (playing === key) { playing = null; setIcon(key, false); }
          resetBar(key);
        });
        var clear = function () { if (pendingEl) pendingEl.hidden = true; };
        a.addEventListener('playing', clear);
        a.addEventListener('loadedmetadata', clear);
        a.addEventListener('error', function () {
          var code = a.error && a.error.code;
          if (code !== 2 && code !== 3 && code !== 4) return;
          if (playing === key) { playing = null; setIcon(key, false); }
          if (pendingEl) pendingEl.hidden = false;
        });
        pool[key] = a;
      }
      return pool[key];
    }
    document.querySelectorAll('[data-eb-play]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-eb-play');
        if (playing && playing !== key && pool[playing]) {
          pool[playing].pause();
          pool[playing].currentTime = 0;
          setIcon(playing, false);
          resetBar(playing);
        }
        var a = getAudio(key, btn.getAttribute('data-eb-src'));
        if (playing === key) { a.pause(); playing = null; setIcon(key, false); return; }
        var p = a.play();
        if (p && p.catch) p.catch(function (err) {
          var name = err && err.name;
          if (name === 'AbortError') return;
          if (playing === key) { playing = null; setIcon(key, false); }
          if (name !== 'NotAllowedError' && pendingEl) pendingEl.hidden = false;
        });
        playing = key;
        setIcon(key, true);
      });
    });
    document.querySelectorAll('[data-eb-tab]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var t = btn.getAttribute('data-eb-tab');
        document.querySelectorAll('[data-eb-tab]').forEach(function (b) { b.classList.toggle('eb-tab-on', b === btn); });
        document.querySelectorAll('[data-eb-pane]').forEach(function (p) { p.hidden = p.getAttribute('data-eb-pane') !== t; });
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
